"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetSlipState = void 0;
var BetSlipState;
(function (BetSlipState) {
    BetSlipState[BetSlipState["Unknown"] = 0] = "Unknown";
    BetSlipState[BetSlipState["Open"] = 1] = "Open";
    BetSlipState[BetSlipState["Won"] = 2] = "Won";
    BetSlipState[BetSlipState["Lost"] = 3] = "Lost";
    BetSlipState[BetSlipState["Cancelled"] = 4] = "Cancelled";
    BetSlipState[BetSlipState["Paid"] = 5] = "Paid";
    BetSlipState[BetSlipState["Restant"] = 6] = "Restant";
    BetSlipState[BetSlipState["Failed"] = 7] = "Failed";
    BetSlipState[BetSlipState["Requested"] = 8] = "Requested";
    BetSlipState[BetSlipState["Rejected"] = 9] = "Rejected";
    BetSlipState[BetSlipState["Delayed"] = 10] = "Delayed";
    BetSlipState[BetSlipState["CashedOut"] = 11] = "CashedOut";
})(BetSlipState = exports.BetSlipState || (exports.BetSlipState = {}));
